<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2
      mat-dialog-title
      class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"
    >
      {{ this.heading | titlecase }}
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    mat-dialog-close
  >
    <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div
    [formGroup]="this.form"
    class="flex lg:flex-col md:flex-col flex-col"
  >
    <mat-form-field class="flex-1 relative form-field" appearance="fill">
      <input
        formControlName="inputField"
        type="number"
        [min]="
          this.country == 'Ghana'
            ? this._data?.walletData?.minimumGhana
            : this._data?.walletData?.minimumNigeria
        "
        matInput
        class="mt-1"
        [placeholder]="this.placeholder"
      />
      <mat-error>{{
        this.form.get("inputField").hasError("required")
          ? errorMessage
          : this.minValueError
      }}</mat-error>
    </mat-form-field>

    <div [class.hidden]="!_data?.remark">
      <mat-form-field
        class="flex-1 relative form-field w-full"
        appearance="fill"
      >
        <input
          formControlName="remark"
          matInput
          class="mt-1"
          placeholder="Add Remarks (Optional)"
        />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="_data?.type != 'html'"
  class="mt-2 !pb-5 !px-0 justify-center"
>
  <button
    color="primary"
    [disabled]="this.form.get('inputField').invalid"
    (click)="onConfirm()"
    class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
    mat-flat-button
  >
    {{ this.btnLabel | titlecase }}
  </button>
</mat-dialog-actions>
